import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ValveDeficiencyTableRow from '../../components/valveDeficiencies/ValveDeficiencyTableRow';
import CircleButton from '../../components/CircleButton';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { deleteValveDeficiency, getValveDeficienciesByValveId } from '../../services/api';
import AddValveDeficiencyModal from './AddValveDeficiencyModal';

const ValveDeficiencies = () => {
  const [loading, setLoading] = useState(true);
  const [valveDeficiencies, setValveDeficiencies] = useState([]);
  const [addValveDeficiencyModalOpen, setAddValveDeficiencyModalOpen] = useState(false);
  const { valveId } = useParams();

  useEffect(() => {
    setupValveDeficiencies();
  }, [valveId]);

  const setupValveDeficiencies = async () => {
    setLoading(true);
    const result = await getValveDeficienciesByValveId(valveId);
    console.log('Valve Deficiencies', result);
    const resultSorted = result?.sort((a, b) => a.resolved === b.resolved ? (a.name <= b.name ? -1 : 1) : a.resolved ? 1 : -1) ?? [];
    setValveDeficiencies(resultSorted);
    setLoading(false);
  };

  const handleDelete = async id => {
    await deleteValveDeficiency(id);
    await setupValveDeficiencies();
  };

  const handleAddValveDeficiency = async () => {
    setAddValveDeficiencyModalOpen(false);
    await setupValveDeficiencies();
  };

  const handleEdit = async () => {
    await setupValveDeficiencies();
  };

  const rows = valveDeficiencies.map((c, idx) => (
    <ValveDeficiencyTableRow key={idx} valveDeficiency={c} onDelete={() => handleDelete(c.id)} onEdit={handleEdit} />
  ));

  return (
    <div className="valve-deficiencies">
      <h2>Valve Deficiencies</h2>
      {loading ? (
        <div className="spinner"></div>
      ) : (
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Type</th>
              <th>Note</th>
              <th>Resolved</th>
              <th className='command-row'>
                <CircleButton icon={faPlus} type="success" title="Add Deficiency" onClick={() => setAddValveDeficiencyModalOpen(true)} />
              </th>
            </tr>
          </thead>
          <tbody>
            {rows}
          </tbody>
        </table>
      )}
      <AddValveDeficiencyModal open={addValveDeficiencyModalOpen} valveId={valveId} onCancel={() => setAddValveDeficiencyModalOpen(false)} onComplete={handleAddValveDeficiency} />
    </div>
  );
};

export default ValveDeficiencies;